import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_guest-intelligence/artifacts/psc4xkgd_stori-logo.png";

export default function StoriLogo({ className = "h-8 w-auto" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Stori"
      data-testid="stori-logo"
      className={`${className} object-contain select-none`}
      draggable={false}
    />
  );
}
